import React from "react";
import { FaArrowCircleRight } from "react-icons/fa";
import "./MissingWaterInvoices.scss";

export default function MissingWaterInvoices({ apartment, month, year, onNavigateToPage }) {
  return (
    <div className="missing-water-invoices">
      <div>Create water invoices for {apartment} in {month} {year} before creating rent invoices.</div>
      {onNavigateToPage && (
        <button type="button" onClick={() => onNavigateToPage("Water", { apartment, month, year })}>
          Go to water invoices <FaArrowCircleRight aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
